module.exports = __webpack_public_path__ + "static/media/Artboard11s.e3570081.gif";